import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { AdmPanelContainer } from "../../../../adm-panel/site/api/screens";
import { SubscriptionsReportFactoryImpl } from "../factories";
import { ISubscriptionsReportData } from "../interfaces/factories";
import { SubscriptionReportHeader } from "./components";

export const SubscriptionsReportPage: React.FC = () => {
    const { t } = useTranslation('reports');
    const [data, setData] = useState<ISubscriptionsReportData>({
        success: false,
        response: ""
    });

    const subscriptionsReportFactory = new SubscriptionsReportFactoryImpl();

    const content =
        <> <h4 className="mb-4">{t('page_title')}</h4>
            <Card>
                <Card.Body>
                    <SubscriptionReportHeader handleData={setData} />
                </Card.Body>
            </Card>

            <Card className="mt-3">
                <Card.Body>
                    {subscriptionsReportFactory.create(data, t)}
                </Card.Body>
            </Card>
        </>

    return <AdmPanelContainer children={content} />
}
